<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2023-07-03 11:37:16
-->
<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-input v-model="queryParam.key"
                  size="mini"
                  clearable
                  placeholder="请输入关键词查找" />
      </div>
      <div class="shaixuan-item">
        <el-button type="primary"
                   size="mini"
                   @click="searchClick()"
                   icon="el-icon-search">
          查询
        </el-button>
        <el-button @click="clickItem(0)"
                   type="primary"
                   size="mini"
                   icon="el-icon-plus">
          新增
        </el-button>
      </div>
    </div>
    <!-- 列表展示 -->
    <div class="common-section-bg common-section-body">
      <el-table v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px">
        <el-table-column prop="id"
                         label="id"
                         width="180" />
        <el-table-column prop="title"
                         label="名称"
                         width="200" />
        <!-- <el-table-column label="广告位">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ad_pos.is_mobile == 0">pc</el-tag>
            <el-tag v-if="scope.row.ad_pos.is_mobile == 1">移动端</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="广告位"
                         prop="adpos_name">
        </el-table-column>
        <el-table-column prop="admin"
                         label="排序">
          <template slot-scope="scope">
            <el-input-number size="mini"
                             style="width: 100px"
                             v-model="scope.row.sort"
                             controls-position="right"
                             @change="handleChange(scope.row)"
                             :min="0"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       :active-value="true"
                       :inactive-value="false"
                       @change="changeStatus(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="180">
          <template slot-scope="scope">
            <div class="btns-wrap">
              <el-button type="danger"
                         size="mini"
                         @click="remove(scope.row)">删除</el-button>
              <el-button type="danger"
                         style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                         size="mini"
                         @click="clickItem(1, scope.row)">修改</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total"
                  :total="total"
                  :page.sync="queryParam.page"
                  :limit.sync="queryParam.size"
                  @pagination="getList" />
    </div>
    <el-drawer custom-class="custom-drawer"
               :visible.sync="showDrawer"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="closeDrawerFun" />
        </div>
      </template>
      <div class="custom-content">
        <BannerAdd ref="BannerAdd"
                   @onUpdateDrawer="onUpdateDrawer($event)" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import ad from "@/api/console/ad";
import BannerAdd from "./BannerAdd.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data () {
    return {
      queryParam: {
        key: "",
        page: 1,
        size: 10,
      },
      total: 0,
      listLoading: false,
      tableData: [],
      isEdit: 0, // 0新增 1编辑
      showDrawer: false,
    };
  },
  components: {
    Pagination,
    BannerAdd,
  },
  created () {
  },
  mounted () {
    this.getList();
  },
  methods: {
    // 排序变更
    handleChange (row) {
      let params = {
        ad_id: row.id,
        sort: row.sort
      };
      ad.bannerSort(params).then(res => {
        if (res.code == 200) {
          this.getList();
        } else {
          this.getList();
          this.$message.error(res.message);
        }
      })
    },
    /**
 * @name: 更改状态
 * @param {*} val
 * @return {*}
 * @desc: 
 */
    changeStatus (val) {
      let params = {
        ad_id: val.id,
        status: val.status
      };
      ad.bannerStatus(params).then(res => {
        if (res.code == 200) {
          this.getList();
        } else {
          this.getList();
          this.$message.error(res.message);
        }
      })
    },
    // 更新弹层状态
    onUpdateDrawer (status) {
      console.log("status", status);
      if (status == 1) {
        // 成功
        this.showDrawer = false;
        this.getList();
      } else if (status == -1) {
        // 失败
        this.showDrawer = false;
      }
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc:
     */
    closeDrawerFun () {
      this.showDrawer = false;
      console.log(this.$refs.BannerAdd)
      this.$refs.BannerAdd.resetForm();
    },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc:
     */
    clickItem (type, row) {
      let that = this;
      this.showDrawer = true;
      this.isEdit = type;
      // 给组件传值
      let obj = {
        type: type,
        id: row ? row.id : "",
      };
      this.$nextTick(function () {
        that.$refs.BannerAdd.initFun(obj);
      });
    },
    /* 查询按钮，页码重置，查询数据 */
    searchClick () {
      this.queryParam.page = 1;
      this.getList();
    },
    /* 查询tableData数据 */
    getList () {
      let that = this;
      this.listLoading = true;
      ad.bannerList(that.queryParam).then((res) => {
        that.listLoading = false;
        that.tableData = res.result.list;
        that.total = res.result.count;
      });
    },
    remove (row) {
      let that = this;
      that.$confirm("确定删除该内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用接口
          ad.bannerRemove({ ad_id: [row.id] }).then((res) => {
            if (res.code == 200) {
              that.$message.success(res.message);
              that.getList();
            } else {
              that.$message.error(res.message);
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
